import { Box } from "@mantine/core";
import { useMemo } from "react";
import { ALLOWED_BRIEFING_TAGS } from "../../constants/recruiterAi";

const ALLOWED = new Set<string>(ALLOWED_BRIEFING_TAGS);

export function sanitizeBriefingHtml(html: string): string {
  if (typeof DOMParser === "undefined") return "";
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
  const root = doc.body.firstElementChild;
  if (!root) return "";
  stripDisallowed(root);
  return root.innerHTML;
}

function stripDisallowed(node: Element) {
  [...node.childNodes].forEach((child) => {
    if (child.nodeType === Node.TEXT_NODE) return;
    if (child.nodeType !== Node.ELEMENT_NODE) {
      child.parentNode?.removeChild(child);
      return;
    }
    const el = child as Element;
    if (!ALLOWED.has(el.tagName)) {
      const parent = el.parentNode;
      while (el.firstChild) parent?.insertBefore(el.firstChild, el);
      el.remove();
      return;
    }
    while (el.attributes.length > 0) {
      el.removeAttribute(el.attributes[0].name);
    }
    stripDisallowed(el);
  });
}

export function HtmlContent({ html }: { html: string }) {
  const sanitized = useMemo(() => sanitizeBriefingHtml(html), [html]);
  if (!sanitized) return null;
  return <Box className="htmlContent" dangerouslySetInnerHTML={{ __html: sanitized }} />;
}